"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Permissions = void 0;
const Permissions = exports.Permissions = {
  // ALERT
  CAN_EDIT_ALERT: "CAN_EDIT_ALERT",
  CAN_VIEW_ALERT: "CAN_VIEW_ALERT",
  // ALERT GROUP
  CAN_EDIT_ALERT_GROUP: "CAN_EDIT_ALERT_GROUP",
  CAN_VIEW_ALERT_GROUP: "CAN_VIEW_ALERT_GROUP",
  // ALERT GROUP USERS
  CAN_EDIT_ALERT_GROUP_USERS: "CAN_EDIT_ALERT_GROUP_USERS",
  CAN_VIEW_ALERT_GROUP_USERS: "CAN_VIEW_ALERT_GROUP_USERS",
  // ALERT PROVIDER
  CAN_EDIT_ALERT_PROVIDER: "CAN_EDIT_ALERT_PROVIDER",
  CAN_VIEW_ALERT_PROVIDER: "CAN_VIEW_ALERT_PROVIDER",
  // ALERT MESSAGE
  CAN_EDIT_ALERT_MESSAGE: "CAN_EDIT_ALERT_MESSAGE",
  CAN_VIEW_ALERT_MESSAGE: "CAN_VIEW_ALERT_MESSAGE",
  // ALERT MESSAGE PROVIDER
  CAN_EDIT_ALERT_MESSAGE_PROVIDER: "CAN_EDIT_ALERT_MESSAGE_PROVIDER",
  CAN_VIEW_ALERT_MESSAGE_PROVIDER: "CAN_VIEW_ALERT_MESSAGE_PROVIDER",
  // ALERT MESSAGE GROUP
  CAN_EDIT_ALERT_MESSAGE_GROUP: "CAN_EDIT_ALERT_MESSAGE_GROUP",
  CAN_VIEW_ALERT_MESSAGE_GROUP: "CAN_VIEW_ALERT_MESSAGE_GROUP",
  // ALERT TASK
  CAN_EDIT_ALERT_TASK: "CAN_EDIT_ALERT_TASK",
  CAN_VIEW_ALERT_TASK: "CAN_VIEW_ALERT_TASK",
  // ESCALATION POLICY
  CAN_EDIT_ESCALATION_POLICY: "CAN_EDIT_ESCALATION_POLICY",
  CAN_VIEW_ESCALATION_POLICY: "CAN_VIEW_ESCALATION_POLICY",
  // ESCALATION LEVEL
  CAN_EDIT_ESCALATION_LEVEL: "CAN_EDIT_ESCALATION_LEVEL",
  CAN_VIEW_ESCALATION_LEVEL: "CAN_VIEW_ESCALATION_LEVEL",
  // ESCALATION EVENT
  CAN_EDIT_ESCALATION_EVENT: "CAN_EDIT_ESCALATION_EVENT",
  CAN_VIEW_ESCALATION_EVENT: "CAN_VIEW_ESCALATION_EVENT",
  // ESCALATION INSTANCE
  CAN_EDIT_ESCALATION_INSTANCE: "CAN_EDIT_ESCALATION_INSTANCE",
  CAN_VIEW_ESCALATION_INSTANCE: "CAN_VIEW_ESCALATION_INSTANCE",
  // ALERT SYSTEM SPREADSHEET
  CAN_EDIT_SPREADSHEET_ALERT_SYSTEM: "CAN_EDIT_SPREADSHEET_ALERT_SYSTEM",
  CAN_VIEW_SPREADSHEET_ALERT_SYSTEM: "CAN_VIEW_SPREADSHEET_ALERT_SYSTEM",
  //SMTP SETTINGS
  CAN_EDIT_ALERT_SMTP_SETTINGS: "CAN_EDIT_ALERT_SMTP_SETTINGS",
  CAN_VIEW_ALERT_SMTP_SETTINGS: "CAN_VIEW_ALERT_SMTP_SETTINGS",
  CAN_EDIT_ALERT_EMAIL_TEMPLATE: "CAN_EDIT_ALERT_EMAIL_TEMPLATE",
  CAN_VIEW_ALERT_EMAIL_TEMPLATE: "CAN_VIEW_ALERT_EMAIL_TEMPLATE"
};